import React, { useState } from 'react';

// components
import ShowProfileModal from '../DashboardFileManagement/CardDetail/ShowProfileModal';
import DashboardHeader from '../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../DashboardReuseAbleComponents/DashboardSideMenu';
import { Dropdown } from "react-bootstrap";
import StaffManagmentLineCharts from '../StaffManagment/StaffManagmentCharts/StaffManagmentLineCharts';
import FinancialSettlementRequestModal from './FinancialSettlementRequestModal';
import RequestForAssistanceModal from "./RequestForAssistanceModal"

// Styles
import styles from "../StaffManagment/StaffManagment.module.css";

// Images
import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg";
import arrowDown from "../../../assets/img/DashboardICons/ArrowDown.svg";
import arrowLeftBlack from "../../../assets/img/DashboardICons/ArrowLeftBlack.svg";
import pourcentStaffBG from "../../../assets/img/DashboardICons/pourcentStaffBG.svg";
import assistanceStaffBG from "../../../assets/img/DashboardICons/assistanceStaffBG.svg";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ConsultantFinancial = () => {
    const history = useHistory();

    const [modalShow, setModalShow] = useState({
        openProfile: false,
        openFinancalModal: false,
        openAssistenceModal: false
    });

    // Select Day Line Chart State
    const [selectDayLine, setSelectDayLine] = useState("ده روز پیش");


    // Data Line Chart Config
    const dataLineChartConfig = {
        borderColor: '#21409A',
        backgroundColor: '#21409A',
        lineTension: 0.3,
        animation: false,
        pointRadius: 0,
    }

    const dataLineChart = {
        responsive: true,
        labels: ['۱ مهر', '۲ مهر', '۳ مهر', '۴ مهر', '۵ مهر', '۶ مهر', '۷ مهر', '۸ مهر', '۹ مهر', '۱۰ مهر'],
        datasets: [
            {
                data: [6000000, 2000000, 360000, 11000000, 38000000, 32000000, 40000000, 46000000, 58000000, 80000000],
                ...dataLineChartConfig
            }
        ],
    };

    // Change Day Line Chart Function
    const selectDayLineHandler = (value) => {
        setSelectDayLine(value)
    }

    return (
        <>

            <style type="text/css">
                {`
                    .dropdown-toggle {
                        height: 35px;
                        font-size: 14px !important;
                        background: #f9f9f9;
                        border: none !important;
                        border-radius: 34px;
                        margin-left: 0.75rem;
                        color: #1D1D1D;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .dropdown-toggle:after,
                    .btn-success:after {
                        content: none;
                    }
                    
                    .btn-success {
                        background: #f9f9f9 !important;
                        color: #1D1D1D !important;
                        box-shadow: none !important;
                    }
                
                    .dropdown-menu {
                        overflow-y: scroll;
                        background: #F9F9F9;
                        border: 1px solid #E1E1E1;
                        border-radius: 34px;
                    }

                    .dropdown-toggle:hover {
                        background: #f4f4f4;
                        color: #1D1D1D;
                        border-color: #e5e5e5;
                        border: 1px solid #e2e2e2;
                    }
                
                   .dropdown-menu::-webkit-scrollbar{
                    width: 3px;
                    height: 50px;
                    }
                    
                    .dropdown-menu::-webkit-scrollbar-track {
                        background: transparent;
                        margin-block: 10px;
                    }
                
                    .dropdown-menu::-webkit-scrollbar-thumb {
                        background: #B4B4B4;
                        border-radius: 20px;
                    }
                
                    .dropdown-item {
                        margin: .5rem 0;
                        padding: .5rem .5rem .5rem 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                
                    .dropdown-item:hover {
                        background: #E7EAF4 !important;
                        border-radius: 24px !important;
                        font-weight: 400;import RequestForAssistanceModal from './RequestForAssistanceModal';

                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                `}
            </style>

            {/* It's a request for assistance. */}

            <FinancialSettlementRequestModal
                show={modalShow.openFinancalModal}
                onHide={() => setModalShow((prev) => {
                    return { ...prev, openFinancalModal: false };
                })}
            />

            <RequestForAssistanceModal
                show={modalShow.openAssistenceModal}
                onHide={() => setModalShow((prev) => {
                    return { ...prev, openAssistenceModal: false };
                })}
            />

            <ShowProfileModal
                show={modalShow.openProfile}
                onHide={() => setModalShow((prev) => {
                    return { ...prev, openProfile: false };
                })}
            />

            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`my-3 pb-4 px-0 ${styles.file_cards_container}`}>
                            <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                            <div
                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                dir="rtl"
                            >
                                <div className='d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                    <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                    <div className={styles.text1}>
                                        امور مالی
                                    </div>
                                </div>
                            </div>

                            <div dir="rtl" className={`d-flex justify-content-between flex-wrap align-items-center mt-4 mx-4 px-2`}>
                                <div className="w-100 d-flex justify-content-between align-items-center flex-wrap">
                                    <div style={{ backgroundColor: "#a3efc87d" }} className={`position-relative overflow-hidden d-flex justify-content-between align-items-center ${styles.total_staff_financial_head_box_consultant}`}>
                                        <h3 className={`mb-0 ${styles.title_staff_financial_head_box}`}> درخواست تسویه مالی </h3>
                                        <img style={{ zIndex: 1 }} src={arrowLeftBlack} alt="arrow-left-black" role="button" onClick={() => setModalShow((prev) => {
                                            return { ...prev, openFinancalModal: true };
                                        })} />
                                        <img className={`position-absolute start-0 ${styles.image_BG_staff_financial_head_box}`} src={pourcentStaffBG} alt="pourcent-staff-BG" />
                                    </div>

                                    <div style={{ backgroundColor: "#FFF9C0" }} className={`position-relative overflow-hidden d-flex justify-content-between align-items-center ${styles.total_staff_financial_head_box_consultant}`}>
                                        <h3 className={`mb-0 ${styles.title_staff_financial_head_box}`}> درخواست مساعده </h3>
                                        <img style={{ zIndex: 1 }} src={arrowLeftBlack} alt="arrow-left-black" role="button" onClick={() => setModalShow((prev) => {
                                            return { ...prev, openAssistenceModal: true };
                                        })} />
                                        <img className={`position-absolute start-0 ${styles.image_BG_staff_financial_head_box}`} src={assistanceStaffBG} alt="assistance-staff-BG" />
                                    </div>
                                </div>
                            </div>

                            <StaffManagmentLineCharts
                                maximumYScaleLineChart={80000000}
                                dataLineChart={dataLineChart}
                            >
                                <div className={`mb-3 pb-4 d-flex align-items-center justify-content-center`}>
                                    <div className={`w-100 d-flex justify-content-between`}>
                                        <h5 className={`m-0 ${styles.total_title_staffline_chart_box}`}> آمار درامد </h5>
                                    </div>

                                    <div>
                                        <Dropdown dir='rtl' onSelect={selectDayLineHandler}>
                                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                {selectDayLine}
                                                <img className='me-3' src={arrowDown} alt="icon" />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="بیست روز پیش">
                                                    بیست روز پیش
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="ده روز پیش">
                                                    ده روز پیش
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="پنج روز پیش">
                                                    پنج روز پیش
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="یک روز پیش">
                                                    یک روز پیش
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                            </StaffManagmentLineCharts>

                            <div dir="rtl" className={`d-flex justify-content-between flex-wrap align-items-center mt-4 mb-3 py-2 mx-4 px-2`}>
                                <div className="w-100 d-flex justify-content-between align-items-center flex-wrap">
                                    <div className={`${styles.total_staff_financial_income_box}`}>
                                        <p className={`mb-0 text-right ${styles.title_staff_financial_income_box}`}> درآمد این هفته </p>
                                        <div className="text-left">
                                            <span className={`${styles.number_staff_financial_income_box}`}> ۱۰,۰۰۰,۰۰۰ </span>
                                            <span className={`${styles.currency_staff_financial_income_box}`}> تومان </span>
                                        </div>
                                    </div>

                                    <div className={`${styles.total_staff_financial_income_box}`}>
                                        <p className={`mb-0 text-right ${styles.title_staff_financial_income_box}`}> درآمد این ماه </p>
                                        <div className="text-left">
                                            <span className={`${styles.number_staff_financial_income_box}`}> ۱۰,۰۰۰,۰۰۰ </span>
                                            <span className={`${styles.currency_staff_financial_income_box}`}> تومان </span>
                                        </div>
                                    </div>

                                    <div className={`${styles.total_staff_financial_income_box}`}>
                                        <p className={`mb-0 text-right ${styles.title_staff_financial_income_box}`}>درآمد کلی شما</p>
                                        <div className="text-left">
                                            <span className={`${styles.number_staff_financial_income_box}`}> ۱۰,۰۰۰,۰۰۰ </span>
                                            <span className={`${styles.currency_staff_financial_income_box}`}> تومان </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu consultantFinancial />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConsultantFinancial;
